const styles = {
  container: {
    fontFamily: "Inter Tight",
    padding: "0 .5vw",
  },
  heading: {
    color: "#0D0D0E",
    fontSize: "18px",
    fontWeight: 500,
  },
  sub_heading: {
    color: "#0D0D0E",
    fontSize: "15px",
    fontWeight: 500,
  },
  text: {
    color: "#949DAA",
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.25px",
  },
  small_sub_heading: {
    color: "#0D0D0E",
    fontSize: "14px",
    fontWeight: 500,
  },
  small_sub_desc: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: "1.4em",
    maxHeight: "2.8em", // 1.4em * 2 lines
  },
  small_text: {
    color: "#949DAA",
    fontSize: "14px",
    fontWeight: 400,
    textTransform: "capitalize",
  },
  columnFlex: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  rowFlex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  budgetContainer: {
    paddingLeft: "2vw",
    borderRadius: "8px",
    marginTop: "1vh",
  },
  budgetRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1vh 1vw",
    borderRadius: "12px",
    background: " #F7F7F7",
    flex: 1,
  },
  milestoneBtn: {
    borderRadius: "4px",
    background: "#4D6BF6",
    padding: ".7vh .7vw",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  },
};

export default styles;
